<template>
      <div class="page-content pb-0 bg-theme">
        <div class="cover-slider owl-carousel owl-dots-no-footer text-center">
          <div data-card-height="cover" class="card bg-transparent">
            <div class="card-center">
              <div class="content mt-n5">
                <img class="mb-3 mx-auto" width="320" src="images/undraw/1.svg" />
                <h1 class="mt-5 mb-0 font-30">TBD</h1>
                <p class="mt-n1 color-highlight font-12">Today Business Women Development Group</p>
                <p class="boxed-text-xl">
                Empowering every wowen one woman at a time
                </p>
              </div>
            </div>
          </div>
          <div data-card-height="cover" class="card bg-transparent">
            <div class="card-center">
              <div class="content mt-n5">
                <img class="mb-3 mx-auto" width="250" src="images/undraw/2.svg" />
                <h1 class="mt-5 mb-0 font-30">Built for You</h1>
                <p class="mt-n1 color-highlight font-12">TBD</p>
                <p
                  class="boxed-text-xl"
                >Empower the lady , empower the nation.</p>
              </div>
            </div>
          </div>
          <div data-card-height="cover" class="card bg-transparent">
            <div class="card-center">
              <div class="content mt-n5">
                <img class="mb-3 mx-auto" width="280" src="images/undraw/3.svg" />
                <h1 class="mt-5 mb-0 font-30">Easy to Use</h1>
                <p class="mt-n1 color-highlight font-12"> For Everyone</p>
                <p class="boxed-text-xl">
                 
                </p>
              </div>
            </div>
          </div>
          <div data-card-height="cover" class="card bg-transparent">
            <div class="card-center">
              <div class="content mt-n5">
                <img class="mb-3 mx-auto" width="270" src="images/undraw/5.svg" />
                <h1 class="mt-5 mb-0 font-28">Never miss our Updates</h1>
                <p
                  class="mt-n1 color-highlight font-12"
                >It's Mobile. So it's super, super fast! Really!</p>
                <p class="boxed-text-xl">
                 
                </p>
              </div>
            </div>
          </div>
          <div data-card-height="cover" class="card bg-transparent">
            <div class="card-center">
              <div class="content mt-n5">
                <img class="mb-3 mx-auto" width="270" src="images/undraw/4.svg" />
                <h1 class="mt-5 mb-0 font-28">Fingertip Features</h1>
                <p class="mt-n1 color-highlight font-12">Everything is built for your Mobile</p>
                <p class="boxed-text-xl">
                  Following strict guideliness for your fingertips to enjoy ever second of tapping through
                  the features.
                </p>
              </div>
            </div>
          </div>
          <div data-card-height="cover" class="card bg-transparent">
            <div class="card-center">
              <div class="content mt-n5">
                <img class="mb-3 mx-auto" width="285" src="images/undraw/6.svg" />
                <h1 class="mt-5 mb-0 font-28">And much more!</h1>
                <p
                  class="mt-n1 color-highlight font-12"
                >All packed together with hundreds of features.</p>
                <p class="boxed-text-xl">
                  TBD in one go
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="cover-button-bottom">
          <router-link
            to="/login"
            class="btn scale-box btn-m mt-5 btn-center-l rounded-l shadow-xl bg-highlight font-800 text-uppercase"
          >
            Get
            Started
          </router-link>
        </div>
        <a href="#" class="cover-next color-gray2-dark">
          Next
          <i class="fa fa-angle-right mr-4 ml-3"></i>
        </a>
        <a href="#" class="cover-prev color-gray2-dark">
          <i class="fa fa-angle-left mr-4 ml-4"></i>Previous
        </a>
      </div>
</template>

<script>

export default {
    mounted() {
      localStorage.getItem("token") ? this.$router.push("/home") : ""
    },
    components:{
    }
}
</script>

<style>
  .bg-highlight{
    background-color: #DA4453!important;
  }
  #app{
    margin-top: 0;
  }
</style>